<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     消息中心-公告列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fnc-notice-list">
    <div class="asst-card flex column align-items-center justify-content-center">
      <div style="font-size: 16px;" class="mb-xs">微信扫一扫</div>
      <div style="font-size: 16px;" class="mb-sm">平台小助理</div>
      <div v-if="!asst_imgurl" v-loading="true" style="width: 100px;height: 100px;" class="mb"></div>
      <el-image v-else class="mb" style="width: 100px; height: 100px"  :src="asst_imgurl" :preview-src-list="[asst_imgurl]"></el-image>
      <div class="text-muted">移动端办公更便捷</div>
    </div>
    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item">
          <div class="f-radios flex">
            <!-- 分离radio -->
            <div v-if="optionsl.length" class="all flex">
              <div
                v-for="item in optionsl"
                :key="item.value"
                role="button"
                :class="item.value == radio ? 'active' : ''"
                class="item"
                @click="handleClick(item)"
              >
                <span>{{ item.title }}</span>
              </div>
            </div>
            <!-- 背景色 -->
            <div class="opts flex">
              <div
                v-for="item in optionsr"
                :key="item.value"
                role="button"
                :class="item.value == radio ? 'active' : ''"
                class="item"
                @click="handleClick(item)"
              >
                <el-badge v-if="item.value == 1 && todo_count" :value="todo_count">
                  <span>{{ item.title }}</span>
                </el-badge>
                <span v-else>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </span>
        <div class="filter-item sm">
          <el-select v-model="listQuery.type" placeholder="类型" clearable style="width: 160px;" @change="fetchData(1)">
            <el-option v-for="item in eventArr" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
      </div>
    </div>
    <el-card v-loading="listLoading" shadow="never" class="notice-container mb-md" :body-style="{ padding: '30px' }">
      <el-table ref="noticeListTable" :data="list" :show-header="false" class="padding-large" style="width: 100%" @row-click="onTableRowClick">
        <el-table-column type="index" label="#" width="60"></el-table-column>
        <el-table-column width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.type == 'equip_auth'" class="icon-item auth" :class="scope.row.status > 0 ? 'grey' : ''">
              <i class="iconfont icon-vesting" />
            </div>
            <div v-if="scope.row.type == 'ap_recover'" class="icon-item recover" :class="scope.row.status  > 0  ? 'grey' : ''">
              <i class="iconfont icon-call-request" />
            </div>
            <div v-if="scope.row.type == 'income_order'" class="icon-item income" :class="scope.row.status  > 0  ? 'grey' : ''">
              <i class="iconfont icon-order-delivery" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="标题">
          <template slot-scope="scope">
            <div :class="scope.row.status  > 0  ? 'text-muted' : 'text-black'" style="font-size: 16px;">
              {{ scope.row.title }}
            </div>
            <div class="text-muted" style="font-size: 12px;height: 17px;line-height: 17px;">{{ scope.row.des }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="right">
          <template slot-scope="scope">
            <span :class="scope.row.status  > 0  ? 'text-muted' : 'text-black'">{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </div>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="listQuery.pindex" :psize.sync="listQuery.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
      </el-table>
    </el-card>
    <todo-detail :show.sync="drawerShow" :tdid="activeRow.tdid" :type="activeRow.type" @change="fetchData"/>
  </div>
</template>
  
<script>
import { godTodoListApi } from "@/api/common/todoApi.js";
import TodoDetail from "./components/TodoDetail.vue";
import { getQrcodeApi } from "@/api/ei/eiApi";

export default {
  name: "Todo",
  components: {
    TodoDetail,
  },
  data() {
    return {
      listLoading: false,
      listQuery: {
        type: "", // 事件类型
        status: 0, // 0: 全部, 1: 未读,
        pindex: 1,
        psize: 10,
      },
      total: 0,
      list: [],

      todoArr: [
        { value: 0, title: "全部", separate: true },
        { value: 1, title: "待处理" },
        { value: 2, title: "已处理" },
      ],
      eventArr: [
        {
          value: "equip_auth",
          label: "提权任务",
        },
        {
          value: "ap_recover",
          label: "复机任务",
        },
        {
          value: "income_order",
          label: "发货任务",
        },
      ],

      optionsl: [],
      optionsr: [],
      radio: 0, // 默认选中全部
      todo_count: 0, // 未处理数量
      drawerShow: false, // 控制抽屉显示
      activeRow: {}, // 当前选中项的ID
    };
  },

  computed: {
    asst_imgurl() {
      return this.$store.state.commonStore.asst_imgurl;
    },

    god() {
      return this.$store.state.godStore;
    },
  },
  watch: {
    radio(newVal) {
      this.listQuery.status = newVal;
      this.fetchData(1);
    },

    god: {
      handler(val) {
        if(val.godid) {
          const param = {
            scene: `godid=${val.godid}`,
            path: "pages/common/member-confirm",
            type: "asst"
          };
          getQrcodeApi(param).then((res) => {
            if (!res.errno) {
              const base64 = btoa(String.fromCharCode(...new Uint8Array(res)));
              const imgUrl = `data:image/png;base64,${base64}`;
              this.$store.commit("SET_ASST_IMGURL", imgUrl);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      },
      deep: true,
    },
  },
  created() {
    this.optionsl = this.todoArr.filter((i) => i.separate);
    this.optionsr = this.todoArr.filter((i) => !i.separate);


    this.fetchData();
  },

  methods: {
    fetchData(page) {
      if (page) this.listQuery.pindex = page;
      this.listLoading = true;
      godTodoListApi(this.listQuery).then((res) => {
        this.listLoading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.todo_count = res.data.todo_count;
        }
      });
    },
    onTableRowClick(row) {
      this.drawerShow = true;
      this.activeRow = row;
    },
    handleClick(item) {
      this.radio = item.value;
    },
  },
};
</script>
  
<style lang="scss" slot-scoped>
.fnc-notice-list {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  .asst-card {
    position: absolute;
    top: 76px;
    right: -155px;
    width: 140px;
    height: 230px;
    border-radius: 5px;
    background-color: rgba(255,255,255,1);
    color: rgba(16,16,16,1);
  }
  .notice-container {
    .el-table .el-table__row {
      cursor: pointer;
    }
    .el-table .cell {
      line-height: 27px;
    }
  }
  .el-badge .el-badge__content.is-fixed {
    top: 0px;
    right: 0px;
  }
  .icon-item {
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    font-size: 40px;
    &.auth {
      color: #07c160;
    }
    &.recover {
      color: #409eff;
    }
    &.income {
      color: #e6a23c;
    }
    &.grey {
      color: #909399;
    }
  }
}
</style>

<style lang="scss" scoped>
.f-radios {
  height: 36px;
  transition: all 0.3s;
  .all {
    margin-right: 10px;
    height: 100%;
    border-radius: 3px;
    background-color: #fff;
    .item {
      padding: 0 20px;
      height: 100%;
      line-height: 36px;
      text-align: center;
      &:hover {
        color: #07c160;
      }
    }
    .active {
      color: #07c160;
      // border-radius: 3px;
      // background-color: rgba(238, 239, 244, 100);
    }
  }
  .opts {
    padding: 4px 10px;
    border-radius: 3px;
    // overflow: hidden;
    background-color: #fff;
    position: relative;
    .item {
      padding: 0 20px;
      height: 100%;
      line-height: 28px;
      text-align: center;
      &:hover {
        color: #07c160;
      }
    }
    .active {
      color: #07c160;
      border-radius: 3px;
      background-color: rgba(238, 239, 244, 100);
    }
  }
}
</style>
  